import styles from "./BackButton.module.scss";
import {ARTIST, Artist} from "../utils/artist.utils";
import {ReactComponent as BackIcon} from "../assets/images/common/back_icon.svg";

type BackButtonProps = {
  artist: Artist;
  onClick: () => void;
  iconType?: "arrow" | "close";
};

const BackButton = ({artist, onClick, iconType = "arrow"}: BackButtonProps) => {
  let backButtonStyle: {color: string; boxShadow: string} = {
    color: "#a749c8",
    boxShadow: "0 2px 0 0 #a749c8",
  };
  if (artist === ARTIST.riize) {
    backButtonStyle = {
      color: "#ffa503",
      boxShadow: "0 2px 0 0 #ffa503",
    };
  }

  const renderIcon = () => {
    if (iconType === "close") {
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.iconClose}
        >
          <path
            d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
            fill="white"
          />
          <path
            d="M15 15L25 25M15 25L25 15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    return <BackIcon className={styles.icon} />;
  };

  const iconAriaLabel = iconType === "close" ? "닫기" : "뒤로 가기";

  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      style={backButtonStyle}
      aria-label={iconAriaLabel}
    >
      {renderIcon()}
    </button>
  );
};

export default BackButton;
